import { useCreationStore } from '../../lib/creationStore'
import { displayHeight, displayWeight } from '../../lib/units'
import { computeEndurance } from '../../lib/computedStats'

export function StepReview() {
  const store = useCreationStore()
  const endurance = computeEndurance(store)

  return (
    <div>
      <h3>Review Character</h3>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem', fontSize: '0.9rem' }}>
        <div><strong>Name:</strong> {store.name || '(unnamed)'}</div>
        <div><strong>Role:</strong> {store.characterRole.toUpperCase()}</div>
        <div><strong>Species:</strong> {store.species_id}</div>
        <div><strong>Sex:</strong> {store.sex}</div>
        <div><strong>Culture:</strong> {store.culture_id}</div>
        <div><strong>Social Class:</strong> {store.social_class}</div>
        <div><strong>Born:</strong> {store.birth_day}/{store.birth_month}/{store.birth_year} TR</div>
        <div><strong>Sunsign:</strong> {store.sunsign_id}{store.on_cusp ? ' (cusp)' : ''}</div>
        <div><strong>Height:</strong> {displayHeight(store.height_inches, 'both')}</div>
        <div><strong>Weight:</strong> {displayWeight(store.weight_lbs, 'both')}</div>
        <div><strong>Frame:</strong> {store.frame}</div>
        <div><strong>Comeliness:</strong> {store.comeliness}</div>
        <div><strong>Occupation:</strong> {store.occupation_name || '(none)'}</div>
        <div><strong>Deity:</strong> {store.deity || 'Agnostic'}</div>
      </div>

      <h4 style={{ marginTop: '1rem', marginBottom: '0.5rem' }}>Attributes</h4>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '0.25rem', fontSize: '0.85rem' }}>
        <div>STR {store.attr_str}</div><div>STA {store.attr_sta}</div>
        <div>DEX {store.attr_dex}</div><div>AGL {store.attr_agl}</div>
        <div>EYE {store.attr_eye}</div><div>HRG {store.attr_hrg}</div>
        <div>SML {store.attr_sml}</div><div>VOI {store.attr_voi}</div>
        <div>INT {store.attr_int}</div><div>AUR {store.attr_aur}</div>
        <div>WIL {store.attr_wil}</div><div>MOR {store.morality}</div>
      </div>
      <div style={{ marginTop: '0.5rem', fontSize: '0.85rem' }}>
        <strong>Endurance:</strong> {endurance}
      </div>
    </div>
  )
}
